import {
    DEBUG_HIDE_DEVTOOLS,
    DEBUG_SHOW_DEVTOOLS,
    //
    DEBUG_HIDE_MEMCONSUMPTION,
    DEBUG_SHOW_MEMCONSUMPTION,
    //
    DEBUG_ENABLE_FORM_DEBUG_ALL,
    DEBUG_DISABLE_FORM_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORM_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORM_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORM_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORM_DEBUG,
    //
    DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG,
    //
    DEBUG_ENABLE_DATATABLE_DEBUG_ALL,
    DEBUG_DISABLE_DATATABLE_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_DATATABLE_DEBUG,
    DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG,
    //
    DEBUG_ENABLE_WEBSOCKET_DEBUG,
    DEBUG_DISABLE_WEBSOCKET_DEBUG
} from '../constants';
import {
    AddDedicatedDataTableDebugAction,
    AddDedicatedFormDebugAction,
    AddDedicatedFormDesignerDebugAction,
    DisableDataTableDebugAllAction,
    DisableDedicatedDataTableDebugAction,
    DisableDedicatedFormDebugAction,
    DisableDedicatedFormDesignerDebugAction,
    DisableFormDebugAllAction,
    DisableFormDesignerDebugAllAction,
    DisableWebSocketDebugAction,
    EnableDataTableDebugAllAction,
    EnableDedicatedDataTableDebugAction,
    EnableDedicatedFormDebugAction,
    EnableDedicatedFormDesignerDebugAction,
    EnableFormDebugAllAction,
    EnableFormDesignerDebugAllAction,
    EnableWebSocketDebugAction,
    HideDevToolsAction,
    HideMemoryConsumptionAction,
    RemoveDedicatedDataTableDebugAction,
    RemoveDedicatedFormDebugAction,
    RemoveDedicatedFormDesignerDebugAction,
    ShowDevToolsAction,
    ShowMemoryConsumptionAction
} from '~/frontend/src/actions/debugConfig';

const relevantActions = [
    DEBUG_HIDE_DEVTOOLS,
    DEBUG_SHOW_DEVTOOLS,
    //
    DEBUG_HIDE_MEMCONSUMPTION,
    DEBUG_SHOW_MEMCONSUMPTION,
    //
    DEBUG_ENABLE_FORM_DEBUG_ALL,
    DEBUG_DISABLE_FORM_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORM_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORM_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORM_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORM_DEBUG,
    //
    DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG,
    //
    DEBUG_ENABLE_DATATABLE_DEBUG_ALL,
    DEBUG_DISABLE_DATATABLE_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_DATATABLE_DEBUG,
    DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG,
    //
    DEBUG_ENABLE_WEBSOCKET_DEBUG,
    DEBUG_DISABLE_WEBSOCKET_DEBUG
];

export type DebugConfigState = {
    show? : boolean;

    memConsumption? : {
        show? : boolean;
        reduxStore? : number;
        elusiveData? : number;
        panelManager? : number;
        session? : number;
        globalData? : number;
        currentPanel? : {
            reduxTotal? : number;
            elusiveData? : number;
            panelManager? : number;
            globalData? : number;
        };
    };

    businessProcessDesignerDebug ?: {
        showAll? : boolean;
        dedicated? : {
            [ chartUid : string ] : boolean;
        };
    };

    chartDesignerDebug? : {
        showAll? : boolean;
        dedicated? : {
            [ chartUid : string ] : boolean;
        };
    };

    dataTableDebug? : {
        showAll? : boolean;
        dedicated? : {
            [ dataTableUid : string ] : boolean;
        };
    };

    formDebug? : {
        showAll? : boolean;
        dedicated? : {
            [ formUid : string ] : boolean;
        };
    };

    formDesignerDebug? : {
        showAll? : boolean;
        dedicated? : {
            [ formUid : string ] : boolean;
        };
    };

    overviewDesignerDebug? : {
        showAll? : boolean;
        dedicated? : {
            [ overviewUid : string ] : boolean;
        };
    };

    webSocketDebug? : boolean;
};

type Action = HideDevToolsAction | ShowDevToolsAction |
    HideMemoryConsumptionAction | ShowMemoryConsumptionAction |
    EnableFormDebugAllAction | DisableFormDebugAllAction |
    AddDedicatedFormDebugAction | RemoveDedicatedFormDebugAction |
    EnableDedicatedFormDebugAction | DisableDedicatedFormDebugAction |
    EnableFormDesignerDebugAllAction | DisableFormDesignerDebugAllAction |
    AddDedicatedFormDesignerDebugAction | RemoveDedicatedFormDesignerDebugAction |
    EnableDedicatedFormDesignerDebugAction | DisableDedicatedFormDesignerDebugAction |
    EnableDataTableDebugAllAction | DisableDataTableDebugAllAction |
    AddDedicatedDataTableDebugAction | RemoveDedicatedDataTableDebugAction |
    EnableDedicatedDataTableDebugAction | DisableDedicatedDataTableDebugAction |
    EnableWebSocketDebugAction | DisableWebSocketDebugAction;


/**
 *
 * @param state
 * @param action
 */
export default function debugInfoReducer( state : DebugConfigState = {}, action : Action ) : DebugConfigState {
    if ( relevantActions.includes( action.type ) ) {
        const newState = { ...state };

        switch ( action.type ) {
            case DEBUG_SHOW_DEVTOOLS:
                newState.show = true;
                break;

            case DEBUG_HIDE_DEVTOOLS:
                newState.show = false;
                break;

            case DEBUG_SHOW_MEMCONSUMPTION:
                newState.memConsumption = {
                    ...newState.memConsumption,
                    show: true
                };
                break;

            case DEBUG_HIDE_MEMCONSUMPTION:
                newState.memConsumption = {
                    ...newState.memConsumption,
                    show: false
                };
                break;

            case DEBUG_ENABLE_FORM_DEBUG_ALL:
                newState.formDebug = {
                    showAll: true
                };
                break;

            case DEBUG_DISABLE_FORM_DEBUG_ALL:
                newState.formDebug = {
                    showAll: false
                };
                break;

            case DEBUG_ADD_DEDICATED_FORM_DEBUG:
                newState.formDebug = {
                    ...newState.formDebug,
                    dedicated: {
                        ...newState.formDebug?.dedicated,
                        [ action.formUid ]: true
                    }
                };
                break;

            case DEBUG_REMOVE_DEDICATED_FORM_DEBUG:
                newState.formDebug = {
                    ...newState.formDebug,
                    dedicated: {
                        ...newState.formDebug?.dedicated
                    }
                };
                delete newState.formDebug!.dedicated![ action.formUid ];
                break;

            case DEBUG_ENABLE_DEDICATED_FORM_DEBUG:
                newState.formDebug = {
                    ...newState.formDebug,
                    dedicated: {
                        ...newState.formDebug?.dedicated,
                        [ action.formUid ]: true
                    }
                };
                break;

            case DEBUG_DISABLE_DEDICATED_FORM_DEBUG:
                newState.formDebug = {
                    ...newState.formDebug,
                    dedicated: {
                        ...newState.formDebug?.dedicated,
                        [ action.formUid ]: false
                    }
                };
                break;

            case DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL:
                newState.formDesignerDebug = {
                    showAll: true
                };
                break;

            case DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL:
                newState.formDesignerDebug = {
                    showAll: false
                };
                break;

            case DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG:
                newState.formDesignerDebug = {
                    ...newState.formDesignerDebug,
                    dedicated: {
                        ...newState.formDesignerDebug?.dedicated,
                        [ action.formUid ]: true
                    }
                };
                break;

            case DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG:
                newState.formDesignerDebug = {
                    ...newState.formDesignerDebug,
                    dedicated: {
                        ...newState.formDesignerDebug?.dedicated
                    }
                };
                delete newState.formDesignerDebug!.dedicated![ action.formUid ];
                break;

            case DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG:
                newState.formDesignerDebug = {
                    ...newState.formDesignerDebug,
                    dedicated: {
                        ...newState.formDesignerDebug?.dedicated,
                        [ action.formUid ]: true
                    }
                };
                break;

            case DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG:
                newState.formDesignerDebug = {
                    ...newState.formDesignerDebug,
                    dedicated: {
                        ...newState.formDesignerDebug?.dedicated,
                        [ action.formUid ]: false
                    }
                };
                break;

            case DEBUG_ENABLE_DATATABLE_DEBUG_ALL:
                newState.dataTableDebug = {
                    showAll: true
                };
                break;

            case DEBUG_DISABLE_DATATABLE_DEBUG_ALL:
                newState.dataTableDebug = {
                    showAll: false
                };
                break;

            case DEBUG_ADD_DEDICATED_DATATABLE_DEBUG:
                newState.dataTableDebug = {
                    ...newState.dataTableDebug,
                    dedicated: {
                        ...newState.dataTableDebug?.dedicated,
                        [ action.dataTableUid ]: true
                    }
                };
                break;

            case DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG:
                newState.dataTableDebug = {
                    ...newState.dataTableDebug,
                    dedicated: {
                        ...newState.dataTableDebug?.dedicated
                    }
                };
                delete newState.dataTableDebug!.dedicated![ action.dataTableUid ];
                break;

            case DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG:
                newState.dataTableDebug = {
                    ...newState.dataTableDebug,
                    dedicated: {
                        ...newState.dataTableDebug?.dedicated,
                        [ action.dataTableUid ]: true
                    }
                };
                break;

            case DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG:
                newState.dataTableDebug = {
                    ...newState.dataTableDebug,
                    dedicated: {
                        ...newState.dataTableDebug?.dedicated,
                        [ action.dataTableUid ]: false
                    }
                };
                break;

            case DEBUG_ENABLE_WEBSOCKET_DEBUG:
                newState.webSocketDebug = true;
                break;

            case DEBUG_DISABLE_WEBSOCKET_DEBUG:
                newState.webSocketDebug = false;
                break;

        }

        return newState;
    }
    else {
        return state;
    }
}
